import {
  Excess,
  InsuranceOptionBase,
  ValueRange,
} from 'scenes/common/flows/coverOptions/types';
import { PaymentFrequency, Campaign } from 'scenes/common/types';
import { WireMotorQuotePayload } from 'scenes/motor/api/quote/types';

export enum MotorCoverSubSection {
  QuotePrice = 'Quote price',
  MotorExcess = 'Motor excess',
  MarketAgreedValue = 'Market or agreed value',
  OptionalExtras = 'Optional extras',
}

export enum MarketAgreedValue {
  Unspecified = '',
  Market = 'Market Value',
  Agreed = 'Agreed Value',
}

export enum MotorInsuranceType {
  Unspecified = '',
  Comprehensive = 'Comprehensive',
  ThirdParty = 'Third Party',
}

export enum MotorCoverType {
  Unspecified = '',
  Comprehensive = 'Comprehensive',
  ComprehensivePlus = 'Comprehensive Plus',
  ThirdPartyFireAndTheft = 'Third Party Fire And Theft',
  ThirdPartyPropertyDamage = 'Third Party Property Damage',
}

export enum OptionalExtra {
  WindScreen = 'WindScreen',
  HireCar = 'HireCar',
  RoadSide = 'RoadSide',
  Under25 = 'Under25',
  Unspecified = '',
}

export enum ExcessType {
  Unspecified = '',
  Standard = 'Standard',
  Additional = 'Additional',
  Imposed = 'Imposed',
  Under20 = 'Under20',
  VehicleModification = 'VehicleModification',
  Voluntary = 'Voluntary',
}

export enum ExcessCode {
  VoluntaryAmt = 'VoluntaryAmt',
  BaseAmt = 'BaseAmt',
  InexperienceExcess = 'InexperienceExcess',
  ExcessForDriverInSpecifiedRange = 'ExcessForDriverInSpecifiedRange',
  UnderAgedDriverExcess = 'UnderAgedDriverExcess',
}

export type InsuranceOption = InsuranceOptionBase & {
  insuranceType: MotorInsuranceType;
  coverType: MotorCoverType;
};

export type VehicleModification = {
  name: string;
  description: string;
};

export type QuoteUserSelections = {
  marketOrAgreedValue: MarketAgreedValue;
  agreedVehicleValue: string;
  excess: Excess;
  insuranceType: MotorInsuranceType;
};

export type MotorQuoteDetails = {
  payload: WireMotorQuotePayload;

  agreedVehicleValueRange: ValueRange;
  vehicleMarketValue: string;
  insuranceOptions: InsuranceOption[];
  excesses: Excess[];
  vehicleModifications: VehicleModification[];

  userSelections: QuoteUserSelections;
  saveQuoteEmailAddress?: string;

  recalculatedInstalments?: {
    firstInstalment: string;
    monthlyInstalment: string;
  };

  receiptNumber?: string;

  campaigns: Campaign[];
};

export interface CoverOptionsData {
  preselectedPaymentFrequency: PaymentFrequency;
  selectedCoverType?: MotorCoverType;
  selectedExtras: string[];
}
